export const heading = { fontFamily: "Plus Jakarta Sans" };
